import { useMemo } from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

const DefouldTooltip = (props) => {
  const { variant = 'primary' } = props;

  const color = useMemo(() => {
    switch (variant) {
      case 'primary': {
        return '#3360ad';
      }
      case 'success': {
        return '#208C72';
      }
      case 'warning': {
        return '#F28520';
      }
      default: {
        return '#3360ad';
      }
    }
  }, [variant]);

  const defaultStyles = useMemo(() => {
    return {
      tooltip: {
        padding: '10px 12px',
        margin: '10px 0!important',
        backgroundColor: '#fff',
        boxShadow: '0px 2px 14px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
        color: '#2D3543',
        fontStyle: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
      },
      tooltipPlacementTop: {
        borderBottom: `4px solid ${color}`,
      },
      tooltipPlacementBottom: {
        borderTop: `4px solid ${color}`,
      },
      popperArrow: {
        '&[x-placement*="top"] .MuiTooltip-arrow': {
          bottom: -2,
        },
        '&[x-placement*="bottom"] .MuiTooltip-arrow': {
          top: -2,
        },
      },
      arrow: { color },
    };
  }, [color]);

  const { children, styles = defaultStyles, ...rest } = props;

  const WhiteTooltip = useMemo(() => {
    return withStyles(() => styles)(Tooltip);
  }, [styles]);

  return (
    <WhiteTooltip {...rest} arrow interactive>
      {children}
    </WhiteTooltip>
  );
};

export default DefouldTooltip;
